import { render, staticRenderFns } from "./RedirectsIndex.vue?vue&type=template&id=7df34872&scoped=true&"
import script from "./RedirectsIndex.vue?vue&type=script&lang=js&"
export * from "./RedirectsIndex.vue?vue&type=script&lang=js&"
import style0 from "./RedirectsIndex.vue?vue&type=style&index=0&id=7df34872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df34872",
  null
  
)

export default component.exports